const Header = ( $ ) => {
	const menuBlock = $(".menu-block");
	const bodyEl = $('body');
	const menuBtn = $(".menu-button");

	menuBtn.on("click", function (e) {
		menuBlock.toggleClass("open");
		bodyEl.toggleClass("open-menu");
	});

	// HIDE CLICK BODY
	$(document).on("click", function (e) {
		if (!$(e.target).closest(".menu-block, .menu-button").length) {
			menuBlock.removeClass("open");
			bodyEl.removeClass("open-menu");
		}
	});


	$('.menu-item-has-children > a').after('<i class="icon-chevron-down"></i>');

	$('.menu-item-has-children > .icon-chevron-down').on('click', function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).parent('.menu-item-has-children').toggleClass('open');
		$(this).siblings('.sub-menu').slideToggle();
	});
}
export default ( ( $ ) => $( Header ) )( jQuery );
